import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const NoRemarksMessage = () => {
  const booking = useAppSelector((state) => state.booking);
  const remarks = booking.bookingRemarks;
  const { t } = useTranslation();

  return (
    <>
      {!remarks || remarks.length < 1 ? (
        <p>{t("bookingDetails.remarks.noRemarks")}</p>
      ) : (
        ""
      )}
    </>
  );
};

export default NoRemarksMessage;
